<pds-module-header title="Publicações" [ctaTemplate]="cta">
	<ng-template #cta>
		<button
			pdsButton="secondary"
			modifier="outlined"
			type="button"
			title="Atualizar listagem de publicações"
			[disabled]="publicationsState.loading"
			(click)="refreshList()"
		>
			<span class="icon">refresh</span>
			<span>Atualizar</span>
		</button>
		<a pdsButton="default" [routerLink]="['/operacoes', 'anymarket', 'configuracoes']">
			Criar Publicação
		</a>
	</ng-template>

	<pds-new-breadcrumb [items]="breadcrumbItems" />

	<main class="anymarket-publisher">
		<pds-panel>
			@if (publicationsState.loading) {
				<p class="anymarket-publisher__feedback">Carregando publicações...</p>
			} @else if (publicationsState.failure) {
				<div class="mb-16">
					<pds-alert type="error" title="Erro ao carregar publicações">Tente novamente em instantes.</pds-alert>
					<button pdsButton="secondary" modifier="outlined" type="button" class="mt-8" (click)="refreshList()">
						<span class="icon">refresh</span>
						<span>Tentar novamente</span>
					</button>
				</div>
			} @else if (publications.length) {
				<pds-table>
					<table>
						<thead>
							<tr>
								<th>Data</th>
								<th>Usuário</th>
								<th>Status</th>
								<th pdsColActions>Ações</th>
							</tr>
						</thead>
						<tbody>
							@for (publication of publications; track publication.id) {
								<tr>
									<td>{{ publication.audit.createdAt | date : 'dd/MM/yyyy HH:mm' }}</td>
									<td>{{ publication.audit.createdBy || '-' }}</td>
									<td>
										<span class="anymarket-publisher__status" [class]="'anymarket-publisher__status--' + (publication.status || '').toLowerCase()">
											{{ statusLabels[publication.status] || publication.status }}
										</span>
									</td>
									<td pdsColActions>
										<button pdsButton="icon" modifier="outlined" type="button" title="Detalhes e planilhas" (click)="openDownloads(publication)">
											<span class="icon">download</span>
										</button>
										<button pdsButton="icon" modifier="outlined" type="button" title="Visualizar filtros" (click)="openFilters(publication)">
											<span class="icon">filter_alt</span>
										</button>
										@if (isProcessing(publication)) {
											<button
												pdsButton="icon"
												modifier="outlined"
												type="button"
												title="Cancelar extração"
												[disabled]="cancelingExtractionId === publication.id"
												(click)="cancelExtraction(publication)"
											>
												<span class="icon">cancel</span>
											</button>
										}
									</td>
								</tr>
							}
						</tbody>
					</table>
				</pds-table>

				<pds-pagination [pagination]="pagination$" (paginate)="onPaginate($event)" />
			} @else {
				<p class="anymarket-publisher__feedback">Nenhuma publicação encontrada.</p>
			}
		</pds-panel>
	</main>
</pds-module-header>

<pds-modal #downloadModal title="Detalhes e planilhas da publicação" [width]="720" (dismiss)="closeDownloads()">
	<div class="anymarket-publisher__details-header">
		<div class="anymarket-publisher__details-meta">
			<span class="anymarket-publisher__details-label">Status:</span>
			<span
				class="anymarket-publisher__status"
				[class]="'anymarket-publisher__status--' + (selectedPublication?.status || '').toLowerCase()"
			>
				{{ statusLabels[selectedPublication?.status || ''] || selectedPublication?.status }}
			</span>
			@if (selectedPublication?.audit?.createdAt) {
				<span class="anymarket-publisher__details-sub">
					Criado em {{ selectedPublication?.audit?.createdAt | date : 'dd/MM/yyyy HH:mm' }}
				</span>
			}
		</div>
		<button
			pdsButton="secondary"
			modifier="outlined"
			type="button"
			title="Atualizar detalhes e arquivos"
			[disabled]="spreadsheetsLoading"
			(click)="refreshDetails()"
		>
			<span class="icon">refresh</span>
			<span>Atualizar</span>
		</button>
	</div>

	@if (spreadsheetsLoading) {
		<p class="anymarket-publisher__feedback">Carregando detalhes e planilhas...</p>
	} @else if (spreadsheetsFailure) {
		<pds-alert type="error" title="Erro ao carregar detalhes">Tente novamente em instantes.</pds-alert>
	} @else if (spreadsheets.length) {
		<div class="anymarket-publisher__downloads-toolbar">
			<span class="anymarket-publisher__downloads-count">
				{{ spreadsheets.length }} arquivo(s) disponível(is)
			</span>
			<button
				pdsButton
				type="button"
				[disabled]="spreadsheets.length === 0 || isDownloadingBatch"
				(click)="downloadAllSpreadsheets()"
			>
				<span class="icon">download</span>
				{{ isDownloadingBatch ? 'Gerando links...' : 'Baixar todos' }}
			</button>
		</div>

		<table class="anymarket-publisher__modal-table">
			<thead>
				<tr>
					<th>Nome do arquivo</th>
					<th>Linhas</th>
					<th>Tamanho</th>
					<th class="anymarket-publisher__col-action">Ação</th>
				</tr>
			</thead>
			<tbody>
				@for (spreadsheet of spreadsheets; track spreadsheet.id) {
					<tr>
						<td>{{ spreadsheet.name }}</td>
						<td>{{ spreadsheet.rows | number }}</td>
						<td>{{ formatSpreadsheetSize(spreadsheet.sizeBytes) }}</td>
						<td class="anymarket-publisher__col-action">
							<button
								pdsButton="icon"
								modifier="outlined"
								type="button"
								[title]="'Baixar ' + spreadsheet.name"
								[disabled]="downloadingFileId === (spreadsheet.name || spreadsheet.id) || isDownloadingBatch"
								(click)="downloadSpreadsheet(spreadsheet)"
							>
								<span class="icon">download</span>
							</button>
						</td>
					</tr>
				}
			</tbody>
		</table>
	} @else {
		@if (selectedPublication && isProcessing(selectedPublication)) {
			<div class="anymarket-publisher__processing-notice">
				<span class="icon">hourglass_empty</span>
				<p>A extração ainda está em processamento. Os arquivos estarão disponíveis assim que for concluída.</p>
				<p class="anymarket-publisher__feedback-hint">Clique em <strong>Atualizar</strong> acima para checar o status novamente.</p>
			</div>
		} @else {
			<p class="anymarket-publisher__feedback">Nenhuma planilha disponível para esta publicação.</p>
		}
	}
</pds-modal>

<pds-modal #filtersModal title="Filtros da publicação" [width]="720" (dismiss)="closeFilters()">
	@if (filtersLoading) {
		<p class="anymarket-publisher__feedback">Carregando filtros...</p>
	} @else if (filtersFailure) {
		<pds-alert type="error" title="Erro ao carregar filtros">Tente novamente em instantes.</pds-alert>
	} @else if (filters.length) {
		<table class="anymarket-publisher__modal-table anymarket-publisher__filters-table">
			<thead>
				<tr>
					<th>Filtro</th>
					<th>Valor</th>
				</tr>
			</thead>
			<tbody>
				@for (filter of filters; track filter.key) {
					<tr>
						<td>{{ filter.key }}</td>
						<td>
							<ul class="anymarket-publisher__filter-values">
								@for (value of filter.value; track value) {
									<li>{{ value }}</li>
								}
							</ul>
						</td>
					</tr>
				}
			</tbody>
		</table>
	} @else {
		<p class="anymarket-publisher__feedback">Nenhum filtro informado.</p>
	}
</pds-modal>
